import { createContext } from 'react';

const UtilidadesContext = createContext();

export default UtilidadesContext;
